export class InformationResponseViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.responseContent = data.responseContent;
        this.userCd = data.userCd;
        this.userName = data.userName;
        this.responseReason = data.responseReason;
        this.isDeleted = data.isDeleted;
    }
    model = null;
    responseContent = 0;
    userCd = -1;
    userName = "";
    responseReason = "";
    isDeleted = false;
}
